import React, { useContext, useEffect, useState } from "react";
import { FolderName, SKMediaType } from "../../../../../api/shared/uploadService";
import VideoInput from "../../VideoInput";
import AudioInput from "../../AudioInput";
import { SKAudioArtifact, SKVideoArtifact, ContentState } from "../../../../../models/SKArtifact";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";

interface AllMediaProps {
  name: string;
  index: number;
  note: string;
  docId: string;
  onValidation?: (name: string, isValid: boolean) => void;
  maxTextLength?: number;
  required?: boolean;
  isEditable?: boolean;
}

export const AllMediaInput = ({
  name,
  onValidation,
  index,
  note,
  docId,
  maxTextLength = 200,
  required = false,
  isEditable = false,
}: AllMediaProps) => {
  const { contentData, artifactId, updateContentData } = useContext(CreateArtifactContext);
  const [selectedMediaType, setSelectedMediaType] = useState<SKMediaType>(SKMediaType.none);
  // const [editable, setEditable] = useState<boolean>(true);

  useEffect(() => {
    if (contentData && (contentData as any).coverMedia?.coverAudioURL) {
      setSelectedMediaType(SKMediaType.audio);
    }
    if (contentData && (contentData as any).coverMedia?.coverVideoURL) {
      setSelectedMediaType(SKMediaType.video);
    }
  }, [contentData]);

  const handleMediaTypeChange = (type: SKMediaType) => {
    isEditable && setSelectedMediaType(type);
  };

  const getImageSource = (mediaType: SKMediaType): string => {
    if (isEditable) {
      return selectedMediaType === mediaType ? "/icons/CheckFilled.png" : "/icons/CheckInactive.png";
    } else {
      return selectedMediaType === mediaType ? "/icons/checkeditem.png" : "/icons/CheckInactive.png";
    }
  };

  return (
    <div>
      <div className="relative w-full min-w-[200px]">
        <div className="flex items-center">
          {index && <span className="content_count">{index}</span>}
          {name && <span className="content_title">{name}</span>}
        </div>
        <div className="notes-class-content">{note}</div>
      </div>
      <div className="flex flex-col">
        {[
          { type: SKMediaType.none, label: "None" },
          { type: SKMediaType.video, label: "Video" },
          { type: SKMediaType.audio, label: "Audio" },
        ].map(({ type, label }, index) => (
          <div key={index}>
            <label key={type} className={`inline-flex items-center ${isEditable ? "cursor-pointer" : ""}`}>
              <input
                type="radio"
                name="mediaType"
                value={type}
                checked={selectedMediaType === type}
                onChange={() => handleMediaTypeChange(type)}
                className="hidden peer"
              />
              <div className="radio-button-default">
                <img src={getImageSource(type)} alt={`${label} Icon`} className="inline-block object-contain h-auto" />
              </div>
              <span className="radio-button-choose">{label}</span>
            </label>
            <div className="my-2 thinseparator mt-[15px] mb-[15px]"></div>
          </div>
        ))}
      </div>
      <div id="multimedia" className={selectedMediaType ? "mt-[15px]" : ""}>
        {selectedMediaType === SKMediaType.video && (
          <VideoInput
            onFileChange={fileUrl => {
              const newCoverMedia = {
                ...contentData.coverMedia,
                coverVideoURL: fileUrl,
              };
              delete newCoverMedia.coverAudioURL;
              isEditable && updateContentData({ coverMedia: { ...newCoverMedia } });
            }}
            docId={docId}
            videoUrl={(contentData as SKVideoArtifact)?.coverMedia?.coverVideoURL}
            maxVideoDuration={90}
            maxFileSize={100}
            editable={isEditable}
            folder={FolderName.content}
          />
        )}
        {selectedMediaType === SKMediaType.audio && (
          <AudioInput
            audioUrl={(contentData as SKAudioArtifact)?.coverMedia?.coverAudioURL}
            docId={artifactId!}
            onFileChange={fileUrl => {
              const newCoverMedia = {
                ...contentData.coverMedia,
                coverAudioURL: fileUrl,
              };
              delete newCoverMedia.coverVideoURL;
              isEditable && updateContentData({ coverMedia: { ...newCoverMedia } });
            }}
            editable={isEditable}
            removeAudio={
              isEditable
                ? () => {
                    const newCoverMedia = {
                      ...contentData.coverMedia,
                    };
                    delete newCoverMedia.coverVideoURL;
                    updateContentData({ coverMedia: { ...newCoverMedia } });
                  }
                : undefined
            }
            folder={FolderName.content}
            maxAudioDuration={5400} // 90 minutes
            maxFileSize={50}
          />
        )}
      </div>
    </div>
  );
};
